import React, { useEffect } from 'react'
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table"
import Select from 'react-select';
import { customStyles } from '../utils/selectStyles';

function TableHistoricoEscolar({ columns, data, filterSelect, setSelectTopico, filterTipo = [], setSelectedTipo, length = true, search = true, titulo = '', pageSize: externalPageSize, setPageSize: externalSetPageSize, showPageSize = true }) {

    const props = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: externalPageSize || 20 }

        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize: internalSetPageSize,
        state: { pageIndex, pageSize: internalPageSize, globalFilter }
    } = props;

    const pageSize = externalPageSize !== undefined ? externalPageSize : internalPageSize;
    const setPageSize = externalSetPageSize || internalSetPageSize;

    // Sincronizar pageSize externo com interno
    useEffect(() => {
        if (externalPageSize !== undefined && externalSetPageSize && externalPageSize !== internalPageSize) {
            internalSetPageSize(externalPageSize);
        }
    }, [externalPageSize, internalPageSize, internalSetPageSize, externalSetPageSize]);

    return (
        <>
            <section className="w-100 mt-3">
                <div className="d-flex flex-column">
                    <div className="row d-flex align-items-center justify-content-between">
                        <div className={`col-md-4 ${search === false && 'd-none'}`}>
                            <div className="inner-addon right-addon">
                                <i className="d-flex bi bi-search" />
                                <input
                                    value={globalFilter || ""}
                                    onChange={e => setGlobalFilter(e.target.value)} type="search"
                                    placeholder="Pesquise o aluno desejado..."
                                    className="form-control py-2"
                                />
                            </div>
                        </div>
                        {filterSelect && filterSelect.length > 0 && (
                            <div className={`d-flex mt-2 mt-md-0 align-items-center justify-content-end ${search === false ? 'col-md-10' : 'col-md-4'}`}>
                                <Select
                                    options={filterSelect.map((value) => {
                                        return {
                                            value: value.id,
                                            label: `${value.nome}`,
                                        };
                                    })}
                                    styles={customStyles}
                                    placeholder="Selecione o tema desejado"
                                    onChange={(selectedOption) => {
                                        setSelectTopico(selectedOption ? selectedOption.value : null);
                                    }}
                                    isClearable
                                />
                            </div>
                        )}
                        {filterTipo && filterTipo.length > 0 && (
                            <div className="d-flex mt-2 mt-md-0 align-items-center justify-content-end col-md-2">
                                <Select
                                    options={filterTipo.map((value) => {
                                        return {
                                            value: value.value,
                                            label: `${value.label}`,
                                        };
                                    })}
                                    defaultValue={filterTipo.length > 0 ? { value: filterTipo[0].value, label: filterTipo[0].label } : null}
                                    styles={customStyles}
                                    placeholder="Filtro"
                                    onChange={(selectedOption) => {
                                        setSelectedTipo && setSelectedTipo(selectedOption ? selectedOption.value : null);
                                    }}
                                />
                            </div>
                        )}
                        {showPageSize && (
                            <div className="d-flex mt-2 mt-md-0 align-items-center justify-content-end col-md-2">
                                <select className="form-select py-2" value={pageSize} onChange={e => { setPageSize(Number(e.target.value)) }}>
                                    <option disabled>Quantidade</option>
                                    {[20, 50, 100, 500, 1000].map(size => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table {...getTableProps()} className="table align-middle mt-1 table-striped table-hover">
                        <thead>
                            <tr>
                                <th colSpan="6" className='bg-primary text-white rounded-top'>{titulo}</th>
                            </tr>
                        </thead>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()} className='border border-white'>
                                    {headerGroup.headers.map(column => (
                                        <th 
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className={`text-uppercase text-black-50 fw-medium fs-8 ${
                                                column.id === 'acoes' ? 'text-center' : ''
                                            } ${column.canSort ? 'cursor-pointer' : ''}`}
                                        >
                                            {column.render('Header')}
                                            {column.canSort && (
                                                <span className="ms-2">
                                                    {column.isSorted ? (
                                                        column.isSortedDesc ? (
                                                            <i className="bi bi-sort-down"></i>
                                                        ) : (
                                                            <i className="bi bi-sort-up"></i>
                                                        )
                                                    ) : (
                                                        <i className="bi bi-arrow-down-up text-muted"></i>
                                                    )}
                                                </span>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}

                        </tbody>
                        <tfoot>
                            <tr className='text-nowrap'>
                                <th colSpan="7" className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {pageSize < rows.length ? pageSize : rows.length} de {rows.length} registros</span>
                                        <div>
                                            <span className='ms-3'>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )

}
export default TableHistoricoEscolar;